import { Typography } from 'antd';
import { MsToTime } from 'components/libs/readyToUse/challengerClasse/utils/Formatters';
import { useCountdown } from 'components/libs/readyToUse/challengerClasse/utils/timerExpirationHook';
import React from 'react';
import './CountdownTimer.css';

const { Text } = Typography;

interface CountdownTimerProps {
  endDate: any;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ endDate }) => {

  const [days, hours, minutes, seconds] = useCountdown(endDate);

  if (days + hours + minutes + seconds <= 0) {
    endDate.initialise();
    return null;
  }

  return (
    <div className="countdown-timer">
      <Text className="timer-text">
        <MsToTime hours={hours} seconds={seconds} minutes={minutes} />
      </Text>
    </div>
  );
};

export default CountdownTimer;
